import { memo } from "react";
import { useSelector } from "react-redux";

import {
  COLLECTIONS_PLAN_TYPE,
  LOCATIONS_PLAN_TYPE,
  OVERRIDES_PLAN_TYPE,
} from "../../../consts/planTypes";

import { getMatrixProfileType } from "../../../reducers/matrixProfile/selectors";
import { mapEditModeSelector } from "../../../reducers/depot/selectors";

import { useLocationDetails } from "../../../hooks/useLocationDetails";

import { CollectionSections } from "./CollectionSections";
import { LocationSections } from "./LocationSections";
import { OverrideSections } from "./OverrideSections";
import { DefaultSections } from "./DefaultSections";
import { MapSections } from "./MapSections";
import { DriverManagementSections } from "./DriverManagementSections";
import { SectionManagementSections } from "./SectionManagementSections";
import { RouteManagementSections } from "./RouteManagementSections";
import { ShiftManagerManagementSections } from "./ShiftManagerManagementSections";

const getRouteSectionsForType = (type) => {
  switch (type) {
    case COLLECTIONS_PLAN_TYPE:
      return <CollectionSections />;
    case OVERRIDES_PLAN_TYPE:
      return <OverrideSections />;
    case LOCATIONS_PLAN_TYPE:
      return <LocationSections />;
    default:
      return <DefaultSections />;
  }
};

const PlanManagementSectionTypes = () => {
  const isMapEditMode = useSelector(mapEditModeSelector);
  const planType = useSelector(getMatrixProfileType);

  if (isMapEditMode) return <MapSections />;
  else return getRouteSectionsForType(planType);
};

export const AppSections = memo(() => {
  const {
    isPlanManagement,
    isDriverManagement,
    isSectionManagement,
    isRouteManagement,
    isShiftManagerManagement,
  } = useLocationDetails();

  if (isPlanManagement) return <PlanManagementSectionTypes />;
  else if (isDriverManagement) return <DriverManagementSections />;
  else if (isSectionManagement) return <SectionManagementSections />;
  else if (isRouteManagement) return <RouteManagementSections />;
  else if (isShiftManagerManagement) return <ShiftManagerManagementSections />;
  else return null;
});
